import { NgModule } from "@angular/core";
import { ScrollingModule } from "@angular/cdk/scrolling";
import {
  MatToolbarModule,
  MatButtonModule,
  MatExpansionModule,
  MatSidenavModule,
  MatTableModule,
  MatIconModule,
  MatListModule,
  MatPaginatorModule,
  MatSortModule,
  MatFormFieldModule,
  MatInputModule,
  MatCheckboxModule,
  MatDialogModule,
} from "@angular/material";

@NgModule({
  exports: [
    MatToolbarModule,
    MatButtonModule,
    MatDialogModule,
    MatFormFieldModule,
    MatExpansionModule,
    MatCheckboxModule,
    ScrollingModule,
    MatInputModule,
    MatSidenavModule,
    MatTableModule,
    MatIconModule,
    MatListModule,
    MatPaginatorModule,
    MatSortModule,
  ],
})
export class MaterialModule {}
